export interface ExistingPermission {
  channelId: number;
  permissionId: number;
}

export interface PermissionDiff {
  toCreate: number[];
  toDelete: ExistingPermission[];
}

/**
 * Computes the create/delete operations needed to move from a curator's
 * existing channel permissions to the operator's current selection.
 */
export function permissionDiff(
  existing: ExistingPermission[],
  selectedChannelIds: number[]
): PermissionDiff {
  const existingIds = new Set(existing.map((p) => p.channelId));
  const selectedSet = new Set(selectedChannelIds);

  const toCreate = selectedChannelIds.filter((id) => !existingIds.has(id));
  const toDelete = existing.filter((p) => !selectedSet.has(p.channelId));

  return { toCreate, toDelete };
}
